import { initWorkItemsRoot } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/index.js?vue3';
import { initJiraIssuesImportStatusRoot } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/index.js?vue3';

initWorkItemsRoot();
initJiraIssuesImportStatusRoot();
